import MuiCard from '@mui/material/Card';
import { FC, PropsWithChildren } from 'react';

interface CardProps {
  width?: string;
  height?: string;
  maxWidth?: string;
  maxHeight?: string;
}

const defaultProps = {
  width: undefined,
  height: undefined,
  maxWidth: undefined,
  maxHeight: undefined,
};

const Card: FC<PropsWithChildren<CardProps>> = ({
  children,
  width,
  height,
  maxWidth,
  maxHeight,
}) => (
  <MuiCard sx={{ width, height, maxWidth, maxHeight, overflow: 'auto', position: 'relative' }}>
    {children}
  </MuiCard>
);

Card.defaultProps = defaultProps;

export default Card;
